import { render, staticRenderFns } from "./FeeMode.vue?vue&type=template&id=453a044c&scoped=true"
import script from "./FeeMode.vue?vue&type=script&lang=ts"
export * from "./FeeMode.vue?vue&type=script&lang=ts"
import style0 from "./FeeMode.vue?vue&type=style&index=0&id=453a044c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "453a044c",
  null
  
)

export default component.exports